export { default } from './prospect-tags-row';
